import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import AppConfig from 'config'
import { useDebouncedCallback } from 'use-debounce'
import useRemoteConfigParams from 'storage/useRemoteConfigParams'

const useTranslationsUpdater = () => {
  const { i18n } = useTranslation(undefined, { useSuspense: false })
  const { params } = useRemoteConfigParams()
  const debouncedReload = useDebouncedCallback(
    () => i18n.reloadResources(),
    200
  )
  useEffect(() => {
    // Reload resources on app start to refresh cached translations + debounced to prevent multiple reloads
    debouncedReload()
    if (!AppConfig.i18n.updateInterval) {
      return
    }
    const interval = setInterval(() => {
      i18n.reloadResources()
    }, AppConfig.i18n.updateInterval)
    return () => clearInterval(interval)
  }, [params])
}

export { useTranslationsUpdater }
